import { render, staticRenderFns } from "./PurchaseVatRegimeMultiSelect.vue?vue&type=template&id=1d3f8f04&scoped=true"
import script from "./PurchaseVatRegimeMultiSelect.vue?vue&type=script&lang=ts"
export * from "./PurchaseVatRegimeMultiSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3f8f04",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d3f8f04')) {
      api.createRecord('1d3f8f04', component.options)
    } else {
      api.reload('1d3f8f04', component.options)
    }
    module.hot.accept("./PurchaseVatRegimeMultiSelect.vue?vue&type=template&id=1d3f8f04&scoped=true", function () {
      api.rerender('1d3f8f04', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/PurchaseVatRegimeMultiSelect.vue"
export default component.exports